import { createStyles, makeStyles } from 'ui-components';

export default makeStyles(() => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    minWidth: 0,
  },
}), { name: 'RetirementCalculatorLimits' });
